module.exports = __webpack_public_path__ + "static/media/img005.091f20a7.jpg";